import { render, staticRenderFns } from "./fbaMatchNotice.vue?vue&type=template&id=667d71da&scoped=true&"
import script from "./fbaMatchNotice.vue?vue&type=script&lang=js&"
export * from "./fbaMatchNotice.vue?vue&type=script&lang=js&"
import style0 from "./fbaMatchNotice.vue?vue&type=style&index=0&id=667d71da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d71da",
  null
  
)

export default component.exports